/**
 * Inventory variant-key helper — frontend mirror of `server/utils/inventoryProductKey.ts`.
 *
 * A second row for the same physical product in a section gets
 * `product_key = '<baseKey>__v<n>'` (n ≥ 2). Reports must recombine sibling
 * variant rows into ONE product wherever counts join order data, because
 * purchases/needs/prices all sit on the base key.
 */

const VARIANT_SUFFIX = /__v\d+$/;

/** Strip a trailing variant suffix (`__v<n>`): `'A1-hanos__v2'` → `'A1-hanos'`. */
export function baseProductKey(key: string): string {
  return key.replace(VARIANT_SUFFIX, '');
}
